import {CountryCode} from 'libphonenumber-js';

/**
 * 로케일 타입
 * 지원하는 언어 코드를 정의합니다.
 */
export type ILocale =
  | 'en-US' // 영어
  | 'ko-KR' // 한국
  | 'zh-CN' // 중국
  | 'zh-TW' // 대만
  | 'uz-UZ' // 우즈벡
  | 'vi-VN' // 베트남
  | 'ru-RU' // 러시아
  | 'th-TH'; // 태국

/**
 * 국가 배열 타입
 * 국가 정보를 담는 객체의 타입입니다.
 * @property {string} code - 국가 전화번호 코드
 * @property {string} country - 국가명 키
 * @property {CountryCode} countryCode - 국가 코드
 * @property {ILocale} languageCode - 언어 코드
 * @property {string} title - 국가 표시명
 */
export type ICountryArray = {
  code: string;
  country: string;
  countryCode: CountryCode;
  languageCode: ILocale;
  title: string;
};

/**
 * 국가 배열
 * 지원하는 국가 목록입니다.
 */
export const countryArray: ICountryArray[] = [
  {
    code: '+82',
    country: 'korea',
    countryCode: 'KR',
    languageCode: 'ko-KR',
    title: '한국어',
  },
  {
    code: '+1',
    country: 'us',
    countryCode: 'US',
    languageCode: 'en-US',
    title: 'English',
  },
  {
    code: '+84',
    country: 'vietnam',
    countryCode: 'VN',
    languageCode: 'vi-VN',
    title: 'Tiếng Việt ',
  },
  {
    code: '+86',
    country: 'china',
    countryCode: 'CN',
    languageCode: 'zh-CN',
    title: '中文',
  },

  {
    code: '+7',
    country: 'russia',
    countryCode: 'RU',
    languageCode: 'ru-RU',
    title: 'Русский',
  },

  {
    code: '+998',
    country: 'uzbekistan',
    countryCode: 'UZ',
    languageCode: 'uz-UZ',
    title: 'o’zbek',
  },
  {
    code: '+66',
    country: 'thailand',
    countryCode: 'TH',
    languageCode: 'th-TH',
    title: 'แบบไทย',
  },
];
